import * as _4 from 'lodash4';
import { ChoiceBuilderDTO } from '../builders/choice_builder';
import { IPollDataStoreDTD } from '../datastore/poll_datastore';
import { IPollAnswerBuilderDTD, IPollAnswerDatastoreDTD } from './../datastore/poll_answer_datastore';
import { IPollStudentBuilderDTD } from './../datastore/poll_student_datastore';
import {
  IChoiceBuilderDTD,
  IChoiceObject,
  IPollBuilderDTD,
  IQuestionBuilderDTD,
  IQuestionXChoiceBuilderDTD,
  IQuestionXChoiceXResourceBuilderDTD,
  IStudentAnswerObject
} from './../poll_interfaces';
import { IPollQueryChoice } from './../queries/poll_query_model';

export interface IBuiltPoll {
  question_x_choice: IQuestionXChoiceBuilderDTD;
  question_x_choice_x_resource: IQuestionXChoiceXResourceBuilderDTD;
  answers: IPollAnswerBuilderDTD;
  question: IQuestionBuilderDTD[];
  first_question_id: number;
  poll: IPollBuilderDTD;
  resource: any;
  is_completed?: boolean;
  selected_resources: any;
}

export interface IPollWithAnswers {
  first_question_id: number;
  poll: IPollBuilderDTD;
  question: IQuestionBuilderDTD[];
  question_x_choice: IQuestionXChoiceBuilderDTD;
  question_x_choice_x_resource: IQuestionXChoiceXResourceBuilderDTD;
  poll_student: IPollStudentBuilderDTD;
  answers?: IPollAnswerBuilderDTD;
  resource?: any;
  selected_resources?: any;
}

export interface IPollReport {
  questions: IQuestionBuilderDTD;
  resource: any;
}

// this is to smooth the inconsistency in the payload and the DS interface
interface IServerPayload {
  poll: IPollBuilderDTD;
  question: IQuestionBuilderDTD;
  choice: IChoiceBuilderDTD;
  question_x_choice: IQuestionXChoiceBuilderDTD;
  first_question_id: number;
}

export class PollResultsServant {
  public buildQuestions(pollPayload: IServerPayload, answerPayload: IPollAnswerDatastoreDTD): any {
    const questions: IQuestionBuilderDTD = pollPayload.question;
    const choices: IChoiceBuilderDTD = pollPayload.choice;
    const answers: IPollAnswerBuilderDTD = answerPayload.answer;
    _4.forEach(questions, (question: any) => {
      question._active_choices = _4.reduce(
        question.active_choices,
        (choiceList: object[], key: number) => {
          const choice: any = choices[key];
          choice.answered = _4.find(
            answers,
            (answer: any): boolean => answer.value === choices[key].nk
          ) as IPollQueryChoice;
          choiceList.push(choice);
          return choiceList;
        },
        []
      );
    });
    return questions;
  }

  public buildPoll(
    pollPayload: IPollWithAnswers | IPollDataStoreDTD,
    answerPayload: IPollAnswerDatastoreDTD,
    pollStudentPayload: IPollStudentBuilderDTD
  ): IBuiltPoll {
    if (!_4.result(pollPayload.poll, 'nk')) {
      pollPayload.poll = _4.first(_4.toArray(pollPayload.poll as any));
    }
    pollPayload.answers = answerPayload.answer;
    pollPayload.poll = _4.merge(pollPayload.poll, pollStudentPayload);
    pollPayload.selected_resources =
      !!pollPayload.selected_resources && pollPayload.selected_resources.length > 0
        ? pollPayload.selected_resources
        : [];
    _4.forEach(pollPayload.poll.answered_questions, (answeredQuestions: IStudentAnswerObject) => {
      if (Array.isArray(answeredQuestions.response)) {
        _4.forEach(answeredQuestions.response, (res: IChoiceObject) =>
          this._addResource(
            {
              questionID: answeredQuestions.questionID,
              response: res
            },
            pollPayload
          )
        );
      } else {
        this._addResource(answeredQuestions, pollPayload);
      }
    });
    return pollPayload as IBuiltPoll;
  }

  public reportPollResults(poll: IBuiltPoll): any {
    const resource: any = poll.selected_resources;
    const pollQuestions: IQuestionBuilderDTD[] = poll.question;
    const question_x_choices: IQuestionXChoiceBuilderDTD = poll.question_x_choice;
    const lookup: object = {};

    _4.forEach(question_x_choices, (q_x_c: any) => {
      lookup[q_x_c.question + '_' + q_x_c.choice] = q_x_c.total_answers;
    });

    const questions = _4.map(pollQuestions, (question: IQuestionBuilderDTD) => {
      question.total_answers = 0;
      const answered: object[] = [];
      const unanswered: object[] = [];
      _4.forEach(question._active_choices, (choice: any) => {
        if (choice.answered) {
          answered.push(choice);
        } else {
          unanswered.push(choice);
        }
        choice.total_answers = lookup[question.id + '_' + choice.id] || 0;
        question.total_answers += choice.total_answers;
      });

      _4.forEach(question._active_choices, (choice: any) => {
        if (_4.isNumber(choice)) {
          return;
        }
        choice.answered_percent = Math.floor((choice.total_answers / question.total_answers) * 1000) / 10;
      });

      return {
        ...question,
        ...{
          answered_active_choices: answered,
          unanswered_active_choices: unanswered
        }
      };
    });

    return { questions, resource };
  }

  _addResource(response: any, pollPayload: IPollWithAnswers | IPollDataStoreDTD) {
    const question = response.questionID;
    const choice = response.response.id;
    const questionXChoiceXResouseObj = _4.filter(_4.toArray(pollPayload.question_x_choice_x_resource), {
      question,
      choice
    });
    _4.forEach(questionXChoiceXResouseObj, (qCR: any) => {
      _4.forEach(qCR.resources, (resourceId: number) => {
        if (!_4.find(pollPayload.selected_resources, { id: resourceId })) {
          pollPayload.selected_resources.push(pollPayload.resource[resourceId]);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/servants/poll_results_servant.ts